module.exports = __webpack_public_path__ + "static/TMD splint-afc99e3044d05baaae02ae2bd347aa3d.jpg";